import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
import sections from 'src/styles/sections';
import helpers from 'src/styles/helpers';
const useStyles = makeStyles(_objectSpread(_objectSpread(_objectSpread({}, sections), helpers), {}, {
  topSectionWrapper: {
    marginTop: '40px'
  },
  addBannerBody: {
    margin: '12px 0 24px 0'
  },
  settingsWrapper: {
    backgroundColor: palette.shades[100],
    marginTop: '24px',
    borderRadius: '2px',
    border: "1px solid ".concat(palette.shades[300])
  },
  settingsSection: {
    padding: '24px',
    '& + &': {
      borderTop: "1px solid ".concat(palette.shades[300])
    }
  },
  modalBody: {
    padding: '32px 40px'
  },
  datePickerWrapper: {
    marginTop: '24px',
    width: '180px'
  },
  bannerListItemWrapper: {
    '& + &': {
      marginTop: '10px'
    }
  },
  bannerListItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  relativeBlock: {
    position: 'relative'
  },
  disabledButton: {
    display: 'inline-block',
    marginLeft: '10px'
  },
  modalTrigger: {
    marginLeft: '10px'
  },
  modalPreview: {
    border: "1px solid ".concat(palette.shades[300])
  },
  modalPreviewTitle: {
    padding: '24px 40px',
    backgroundColor: 'white',
    minHeight: '100px',
    display: 'flex',
    alignItems: 'center',
    borderBottom: "1px solid ".concat(palette.shades[300])
  },
  modalPreviewContent: {
    padding: '24px 40px',
    position: 'relative'
  },
  modalFooter: {
    padding: '32px 40px',
    borderTop: "1px solid ".concat(palette.shades[300])
  },
  cellContent: {
    borderRadius: '2px',
    display: 'flex',
    alignItems: 'center',
    padding: '5px 10px'
  },
  cellLeft: {
    width: '100%'
  },
  link: {
    color: palette.primary.dark
  },
  textContent: {
    '& p': {
      margin: '0'
    }
  }
}));
export default useStyles;